import React from "react";
import IconPhone from "../../../common/assets/icons/IconPhone.png";
import IconLocation from "../../../common/assets/icons/IconLocation.png";
import IconLocationMap from "../../../common/assets/icons/IconLocationMap.png";
import IconMessage from "../../../common/assets/icons/IconMessage.png";
import { Info } from "./Info";
import "../styles/InfoBlock.css";

export const InfoBlock = () => {
  const contactsInfo = [
    { icon: IconPhone, text: "+ 7 (391) 204-08-25" },
    { icon: IconMessage, text: "office@kras-abs.ru" },
    {
      icon: IconLocation,
      text: "Россия, 660135, Красноярский край, г. Красноярск, ул. Взлетная, д.7А, пом.164",
    },
  ];

  const commercialInfo = [
    { icon: IconPhone, text: "+ 7 (391) 292-97-23" },
    { icon: IconMessage, text: "opr@kras-abs.ru" },
  ];

  return (
    <div className="m_ib_main_con">
      <p className="m_ib_contacts_title_top">{"Контактная информация:"}</p>
      <div className="m_ib_info_con">
        <div className="m_ib_info_sub_con">
          <Info
            title={"Контактная информация:"}
            list={contactsInfo}
            titleClass="m_ib_contacts_title"
          />
          <Info
            title={"Коммерческий отдел:"}
            list={commercialInfo}
            titleClass="m_ib_commercial_title"
          />
        </div>
      </div>
      <div className="m_ib_icon_location_map_con">
        <img src={IconLocationMap} alt="" className="m_ib_icon_location_map" />
      </div>
    </div>
  );
};
